import { Flex, Radio } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

export default function YesNoRadio({ field, value, onChange }) {
  const { t } = useTranslation(undefined, { keyPrefix: 'Components:Form:General:YesNoRadio' });

  const yesRadioId = `${field}-radio-true`;
  const noRadioId = `${field}-radio-false`;

  return (
    <Flex gap="large">
      <Flex gap="small">
        <Radio
          checked={value === true}
          onChange={(e) => e.target.checked && onChange(true)}
          id={yesRadioId}
          className="scale-125"
        />
        <label htmlFor={yesRadioId} className="my-auto cursor-pointer">
          {t('options.true')}
        </label>
      </Flex>
      <Flex gap="small">
        <Radio
          checked={value === false}
          onChange={(e) => e.target.checked && onChange(false)}
          id={noRadioId}
          className="scale-125"
        />
        <label htmlFor={noRadioId} className="my-auto cursor-pointer">
          {t('options.false')}
        </label>
      </Flex>
    </Flex>
  );
}
